/******
 * ga统计，区分线上和测试
*****/
import ISONLINE from './domainJudge.js';

// google统计
if (ISONLINE || ISONLINE === undefined) {
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date()
      a = s.createElement(o)
      m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
    ga('create', 'UA-40488675-15', 'auto')
    ga('send', 'pageview')
} else {
    window.ga = function () {
        // 兼容报错
    }
}
